/* ===== NAMIKAZE X — Logo X Gold Script ===== */
(function() {
  function styleLogoX() {
    /* Cible tous les spans/liens qui affichent le nom de la boutique */
    var logoEls = document.querySelectorAll(
      '.header__heading-link .h2, .header__heading-link span, .header__heading-link'
    );
    logoEls.forEach(function(el) {
      /* On ne traite que les noeuds texte directs (pas les images) */
      if (el.children.length === 0 && el.textContent.trim().length > 0) {
        var txt = el.textContent.trim();
        /* Vérifie qu'il contient NAMIKAZE X ou se termine par X */
        if (txt.toUpperCase().includes('NAMIKAZE') || txt.endsWith('X')) {
          /* Remplace le dernier X par un span doré */
          var lastX = txt.lastIndexOf('X');
          if (lastX !== -1) {
            var before = txt.slice(0, lastX);
            var after  = txt.slice(lastX + 1);
            el.innerHTML =
              before +
              '<span class="nmkz-logo-x" aria-hidden="true">X</span>' +
              after;
          }
        }
        return;
      }
      /* Si c'est un conteneur, cherche les noeuds texte enfants */
      el.childNodes.forEach(function(node) {
        if (node.nodeType === 3) { /* TEXT_NODE */
          var txt = node.textContent;
          var lastX = txt.lastIndexOf('X');
          if (lastX !== -1 && txt.toUpperCase().includes('NAMIKAZE')) {
            var span = document.createElement('span');
            span.innerHTML =
              txt.slice(0, lastX) +
              '<span class="nmkz-logo-x">X</span>' +
              txt.slice(lastX + 1);
            node.parentNode.replaceChild(span, node);
          }
        }
      });
    });
  }

  /* Exécute au chargement + après que le DOM soit prêt */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', styleLogoX);
  } else {
    styleLogoX();
  }
  /* Sécurité : re-exécute après 300ms pour les thèmes qui injectent le header en async */
  setTimeout(styleLogoX, 300);
})();
